import type * as SchemaTypes from '../types';

import type { AppointmentModuleSpecsFragment } from './AppointmentModuleSpecs';
import type { SimpleVersioningDataFragment } from './SimpleVersioningData';
import type { AuthorData_CorporateCustomer_Fragment, AuthorData_ExternalBank_Fragment, AuthorData_Guarantor_Fragment, AuthorData_LocalCustomer_Fragment, AuthorData_Salesforce_Fragment, AuthorData_SystemBank_Fragment, AuthorData_User_Fragment } from './AuthorData';
import type { AppointmentTimeSlotDataFragment } from './AppointmentTimeSlotData';
import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { NamirialSigningModuleSpecsFragment } from './NamirialSigningModuleSpecs';
import type { NamirialSettingsSpecFragment } from './NamirialSettingsSpec';
import type { AppointmentModuleEmailContentsSpecsFragment, AppointmentModuleEmailContentCustomerSpecsFragment, AppointmentModuleEmailContentSpecsFragment, AppointmentModuleEmailContentSalesPersonSpecsFragment, AppointmentModuleEmailContentFinderReservationSpecsFragment } from './AppointmentModuleEmailContentsSpecs';
import type { DealerTranslatedStringSettingDataFragment } from './DealerTranslatedStringData';
import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import { gql } from '@apollo/client';
import { AppointmentModuleSpecsFragmentDoc } from './AppointmentModuleSpecs';
import { SimpleVersioningDataFragmentDoc } from './SimpleVersioningData';
import { AuthorDataFragmentDoc } from './AuthorData';
import { AppointmentTimeSlotDataFragmentDoc } from './AppointmentTimeSlotData';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { NamirialSigningModuleSpecsFragmentDoc } from './NamirialSigningModuleSpecs';
import { NamirialSettingsSpecFragmentDoc } from './NamirialSettingsSpec';
import { AppointmentModuleEmailContentsSpecsFragmentDoc, AppointmentModuleEmailContentCustomerSpecsFragmentDoc, AppointmentModuleEmailContentSpecsFragmentDoc, AppointmentModuleEmailContentSalesPersonSpecsFragmentDoc, AppointmentModuleEmailContentFinderReservationSpecsFragmentDoc } from './AppointmentModuleEmailContentsSpecs';
import { DealerTranslatedStringSettingDataFragmentDoc } from './DealerTranslatedStringData';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
export type EventApplicationEntrypointContextDataFragment = (
  { __typename: 'EventApplicationEntrypoint' }
  & Pick<SchemaTypes.EventApplicationEntrypoint, 'id' | 'pathname' | 'displayName'>
  & { eventApplicationModule: (
    { __typename: 'EventApplicationModule' }
    & Pick<SchemaTypes.EventApplicationModule, 'id' | 'vehicleModuleId' | 'customerModuleId' | 'agreementsModuleId' | 'isOcrEnabled' | 'displayAppointmentDatepicker' | 'liveChatSettingId'>
    & { appointmentModule?: SchemaTypes.Maybe<{ __typename: 'AdyenPaymentModule' } | (
      { __typename: 'AppointmentModule' }
      & AppointmentModuleSpecsFragment
    ) | { __typename: 'AudiCalculationModule' } | { __typename: 'AudiFinancingModule' } | { __typename: 'AudiSalesForceModule' } | { __typename: 'AutoplayModule' } | { __typename: 'BankModule' } | { __typename: 'BasicSigningModule' } | { __typename: 'BmwModule' } | { __typename: 'CapModule' } | { __typename: 'ConfiguratorModule' } | { __typename: 'ConsentsAndDeclarationsModule' } | { __typename: 'CtsModule' } | { __typename: 'EventApplicationModule' } | { __typename: 'FinderApplicationPrivateModule' } | { __typename: 'FinderApplicationPublicModule' } | { __typename: 'FinderVehicleManagementModule' } | { __typename: 'FiservPaymentModule' } | { __typename: 'GiftVoucherModule' } | { __typename: 'InsuranceModule' } | { __typename: 'LabelsModule' } | { __typename: 'LocalCustomerManagementModule' } | { __typename: 'MaintenanceModule' } | { __typename: 'MobilityModule' } | { __typename: 'MyInfoModule' } | { __typename: 'NamirialSigningModule' } | { __typename: 'PayGatePaymentModule' } | { __typename: 'PorscheMasterDataModule' } | { __typename: 'PorschePaymentModule' } | { __typename: 'PromoCodeModule' } | { __typename: 'SdmModule' } | { __typename: 'SimpleVehicleManagementModule' } | { __typename: 'StandardApplicationModule' } | { __typename: 'TradeInModule' } | { __typename: 'TtbPaymentModule' } | { __typename: 'UserlikeChatbotModule' } | { __typename: 'WebsiteModule' } | { __typename: 'WhatsappLiveChatModule' }>, company: (
      { __typename: 'Company' }
      & Pick<SchemaTypes.Company, 'timeZone' | 'countryCode'>
    ), liveChatSetting?: SchemaTypes.Maybe<(
      { __typename: 'UserlikeChatbotSetting' }
      & Pick<SchemaTypes.UserlikeChatbotSetting, 'script' | 'id'>
    ) | (
      { __typename: 'WhatsappLiveChatSetting' }
      & Pick<SchemaTypes.WhatsappLiveChatSetting, 'link' | 'id'>
    )> }
  ), pathScripts: Array<(
    { __typename: 'PathScript' }
    & Pick<SchemaTypes.PathScript, 'pathname' | 'script'>
  )> }
);

export const EventApplicationEntrypointContextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EventApplicationEntrypointContextData on EventApplicationEntrypoint {
  id
  pathname
  displayName
  eventApplicationModule {
    id
    vehicleModuleId
    customerModuleId
    agreementsModuleId
    isOcrEnabled
    appointmentModule {
      ...AppointmentModuleSpecs
    }
    displayAppointmentDatepicker
    company {
      timeZone
      countryCode
    }
    liveChatSettingId
    liveChatSetting {
      id
      ... on WhatsappLiveChatSetting {
        link
      }
      ... on UserlikeChatbotSetting {
        script
      }
    }
  }
  pathScripts {
    pathname
    script
  }
}
    `;